<template>
  <div class="login-page items-center justify-center">
    <v-card
      v-if="!showFinishRepassword"
      :loading="loading"
      class="mx-auto item-card"
    >
      <warnningComponent
        v-bind:textInfo.sync="textWarning"
        v-bind:typestatus.sync="typeWarning"
        v-bind:alert.sync="showWarnnig"
      ></warnningComponent>

      <div class="logo-welcome mb-5">
        <v-img :src="company.companies[0].logo"></v-img>
      </div>
      <div class="my-10">
        <v-card-title primary-title class="justify-center pa-0 mb-3 tula-title"
          >Forgot your password?</v-card-title
        >
        <p
          class="body-2 text-center origanization-detail font-weight-regular grey--text text--darken-1"
        >
          {{ 'Do you want to change your password now?' }} <br />
          {{ "When you click RESET, We'll send your new password to " }}
        </p>
        <div class="text-center">
          <span style="color: #1a3f7d !important" class="font-weight-black">{{
            company.username
          }}</span>
        </div>
      </div>
      <div class="text-center mt-2 mb-8">
        <v-btn
          width="50%"
          :disabled="!company.username"
          :color="isVKNOWS? '#4BD0A0' :'#072F72'"
          class="md-w-100 xs-full-width white--text next-btn"
          large
          @click="repassword"
          >RESET</v-btn
        >
      </div>
    </v-card>

    <v-card
      v-if="showFinishRepassword"
      :loading="loading"
      class="mx-auto item-card"
    >
      <warnningComponent
        v-bind:textInfo.sync="textWarning"
        v-bind:typestatus.sync="typeWarning"
        v-bind:alert.sync="showWarnnig"
      ></warnningComponent>

      <div class="titile px-6 mt-5 mb-10">
        <v-card-title
          primary-title
          style="color: #1a3f7d !important"
          class="font-weight-black justify-center pa-0 mb-3 tula-title"
          >Check your email</v-card-title
        >
        <p
          class="subtitle text-center origanization-detail font-weight-regular grey--text text--darken-1"
        >
          {{ 'We have just sent an email with you new password.' }}
        </p>
      </div>
      <div class="text-center px-6 mt-2 mb-8">
        <v-btn
          width="50%"
          color="#072F72"
          class="md-w-100 xs-full-width white--text next-btn"
          large
          @click="goToLogin"
          >Sign in</v-btn
        >
      </div>

      <div class="text-center py-12">
        <p
          class="subtitle text-center origanization-detail font-weight-light grey--text text--lighten-1"
        >
          {{ 'For any further questions or problems, please emailus at' }}
          <span class="font-weight-black">support@deknerd.com</span>
        </p>
      </div>
    </v-card>

    <v-dialog v-model="cantAccess" persistent max-width="450">
      <v-card>
        <v-card-title class="headline"
          >คุณไม่มีสิทธิ์เข้าถึงเว็บไซต์นี้</v-card-title
        >
        <v-card-text>
          <p>กลับไปยังหน้าเข้าสู่ระบบ</p>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            elevation="0"
            class="px-7 ma-2 subtitle-2 font-weight-light"
            color="error darken-1"
            @click="goToLogin()"
            ><p class="pa-0 ma-0">ตกลง</p>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { repassword } from '@/service/account/login';
import { checkDevice } from '@/helper/checkDevice';
import warnningComponent from '../../components/warningAlert.vue';
import { isNerdOf, isVKNOWS } from "../../helper/domain"

export default {
  name: 'enter-password',
  components: {
    warnningComponent,
  },
  computed: {
    isVKNOWS() {
      return isVKNOWS();
    },
    isNerdOf() {
      return isNerdOf();
    },
  },
  data() {
    return {
      dialog: false,
      value: false,
      loading: false,
      valid: true,
      company: JSON.parse(localStorage.getItem('company')),
      passwordRules: [(v) => !!v || 'Password is required'],
      textWarning: '',
      typeWarning: '',
      showWarnnig: false,
      userPassword: '',
      cantAccess: false,
      showFinishRepassword: false,
    };
  },

  methods: {
    async repassword() {
      this.loading = true;
      let idSelectCompany = this.company.companies[0]._id;
      let result = await repassword({
        username: this.company.username,
        company: idSelectCompany,
      });
      if (!result.code) {
        this.loading = false;
        this.showFinishRepassword = true;
      }
    },

    warnnig(text, type) {
      (this.textWarning = text),
        (this.typeWarning = type),
        (this.showWarnnig = true);
    },

    async goToLogin() {
      await this.$router.replace({
        path: '/login',
      });
    },
  },
};
</script>
<style scoped>
.logo-welcome {
  width: 20%;
  /* width: 180px; */
  margin: 0 auto;
}
.login-page {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.item-card {
  /* width: 30%; */
  min-height: 300px;
  padding: 48px 0 0;
}
.rowCard {
  height: 400px;
  margin-top: 20px;
}
.titleCard {
  font-weight: bold;
  margin-top: 10px;
  text-align: center;
  font-size: 30px;
}
.formPassword {
  margin-left: 20px;
  margin-right: 20px;
}
.login-button {
  margin-bottom: 20px;
  width: 100%;
}
.forgotPass {
  margin-right: 100px;
}
.description {
  text-align: center;
}
.company-name {
  display: flex;
  min-width: 300px;
  width: 125px;
  margin: 0 auto;
  justify-content: center;
  border: 1px solid #e0e0e0;
  padding: 5px 0;
  border-radius: 30px;
}
.img-company {
  width: 25px;
  margin-right: 10px;
}
@media only screen and (min-width: 1025px) and (max-width: 1795px) {
  .item-card {
    width: 30%;
  }
}
@media only screen and (min-width: 1796px) {
  .item-card {
    width: 25%;
  }
}

@media only screen and (max-width: 768px) {
  .item-card {
    width: 100%;
    /* min-height: 90%; */
    padding: 36px 0 0;
  }
  .login-page {
    height: 100%;
    align-items: unset;
  }
}
@media only screen and (min-width: 769px) and (max-width: 1024px) {
  .item-card {
    width: 45%;
    min-height: 560px;
  }

  .login-page {
    height: 100%;
    align-items: center;
  }
}
</style>
<style lang="scss">
.iconInput {
  .v-input__control > .v-input__slot > .v-input__append-inner {
    margin-left: auto !important;
    padding-left: 4px !important;
    margin-top: 6px !important;
  }
}
</style>